import { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, space, breakpoint } = theme

export interface SchemaSpanProps extends HTMLAttributes<HTMLSpanElement> {
  content?: string
}

export const SchemaSpan = styled.span<SchemaSpanProps>``

export const Featured = styled.div<{ $imageUrl?: string; $background_color?: string }>`
  padding: ${space.xl};
  background: ${(p) => (p.$imageUrl ? `url(${p.$imageUrl})` : p.$background_color ? p.$background_color : '#ffff')};
  background-repeat: no-repeat;
  background-position: unset;

  @media (min-width: ${breakpoint.lg}) {
    background-position: top center;
    padding: ${space.lg} 0 ${space.xl4};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0 ${space.xl};

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    padding: ${space.xl} ${space.xl3};
  }
`

export const LeftFeatured = styled.div<{ $button_color?: string; $button_text_color?: string; $text_color?: string }>`
  order: 2;
  width: 100%;

  .header_text,
  .header_description,
  .benefits_list,
  .list_text {
    color: ${(props) => props.$text_color};
  }

  .calc_button {
    background-color: ${(props) => props.$button_color};
    border: 1px;
  }

  .button_text {
    color: ${(props) => props.$button_text_color};
  }

  @media (min-width: ${breakpoint.lg}) {
    order: 1;
    width: 60%;
  }
`

export const Product = styled.div`
  order: 1;
  position: relative;
  width: calc(100% + ${space.xl3});
  margin-left: -${space.lg};
  padding-top: ${space.lg};
  background-color: ${color.grayscale.lighter};

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 12%;
    background-color: ${color.grayscale.white};

    @media (min-width: ${breakpoint.lg}) {
      display: none;
    }
  }

  @media (min-width: ${breakpoint.lg}) {
    order: 2;
    width: 40%;
    background-color: transparent;
  }
`

export const ProductImg = styled.div`
  position: relative;
  width: 60%;
  margin: 0 auto;
  padding: ${space.xl} ${space.lg} 0;

  @media (min-width: ${breakpoint.lg}) {
    width: 100%;
  }

  img {
    position: relative;
    z-index: 2;
    display: block;
    width: 100%;
    height: auto;
  }
`

export const ProductType = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 2;
  bottom: 18%;
  left: 0;
  width: 4.5rem;
  height: 4.5rem;
  border: ${borders.sizes.md} solid ${color.grayscale.white};
  border-radius: ${borders.radius.circle};
  background-color: ${color.primary.dark};

  img {
    display: block;
    width: auto;
    max-width: 40px;
    height: 100%;
    max-height: 40px;
  }

  @media (min-width: ${breakpoint.xl}) {
    bottom: 8%;
    width: 7rem;
    height: 7rem;

    img {
      max-height: 62px;
      max-width: 62px;
    }
  }
`

export const FilledSquare = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 72%;
  height: 72%;
  background-color: ${color.grayscale.light};
  border-radius: ${borders.radius.xl};
`

export const OutlinedSquare = styled.div`
  position: absolute;
  top: 5.7%;
  left: 5.7%;
  width: 35%;
  height: 35%;
  border: ${borders.sizes.md} dashed ${color.grayscale.gray};
  border-radius: ${borders.radius.xl};
`
